import { render, staticRenderFns } from "./WorkIconUp.vue?vue&type=template&id=8ceb22d8"
import script from "./WorkIconUp.vue?vue&type=script&lang=js"
export * from "./WorkIconUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports